export default __webpack_public_path__ + "static/media/err-roominfo.4d2ebf3d.svg";